import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {useNavigate, useParams} from "react-router-dom";
import {baseUrl, ipAddress, userName,} from "../Univ.js";
import "./IoTStyles.css";
function IoTGatewayForm() {
    const navigate = useNavigate();
    const {id} = useParams();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        gateway_id: "",
        gateway_name: "",
        ip_address: "",
        port: "",
        farm_code: "",
        location: "",
        version: "",
        status: "OFFLINE"
    });
    // ============================================================
    // LOAD GATEWAY
    // ============================================================
    useEffect(() => {
        if (id) {
            fetchGateway();
        }
    }, [id]);
    const fetchGateway = async () => {
        try {
            setLoading(true);
            const response = await axios.get(baseUrl + "iot-gateways/" + id + "/");
            setFormData({
                ...formData, ...response.data
            });
        } catch (error) {
            console.log("IoT Gateway Load Error:", error);
            Swal.fire("Error", "Unable to load IoT gateway.", "error");
        } finally {
            setLoading(false);
        }
    };
    // ============================================================
    // INPUT HANDLER
    // ============================================================
    const inputHandler = (event) => {
        const {
            name, value
        } = event.target;
        setFormData({
            ...formData, [name]: value
        });
    };
    // ============================================================
    // SUBMIT
    // ============================================================
    const submitHandler = async (event) => {
        event.preventDefault();
        if (!formData.gateway_id || !formData.gateway_name) {
            Swal.fire("Required", "Gateway ID and Gateway Name are required.", "warning");
            return;
        }
        try {
            setLoading(true);
            const payload = {
                ...formData,
                port: formData.port === "" ? null : Number(formData.port),
                addedby: userName,
                ip_add: ipAddress
            };
            let response;
            // ====================================================
            // UPDATE
            // ====================================================
            if (id) {
                response = await axios.put(baseUrl + "iot-gateways/" + id + "/", payload);
            }

                // ====================================================
                // CREATE
            // ====================================================
            else {
                response = await axios.post(baseUrl + "iot-gateways/", payload);
            }
            // ====================================================
            // SUCCESS
            // ====================================================
            if (response.status === 200 || response.status === 201) {
                Swal.fire({
                    title: id ? "Gateway Updated" : "Gateway Registered",
                    text: "Agricultural IoT gateway saved successfully.",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false
                });
                setTimeout(() => {
                    navigate("/iot-gateways/");
                }, 1500);
            }
        } catch (error) {
            console.log("IoT Gateway Save Error:", error);
            let message = "Unable to save IoT gateway.";
            if (error.response && error.response.data) {
                console.log("SERVER RESPONSE:", error.response.data);
                if (error.response.data.detail) {
                    message = error.response.data.detail;
                } else {
                    message = JSON.stringify(error.response.data);
                }
            }
            Swal.fire("Error", message, "error");
        } finally {
            setLoading(false);
        }
    };
    // ============================================================
    // UI
    // ============================================================
    return (<section className="container mt-4">


            {/* ====================================================
                HEADER
            ==================================================== */}

            <div className="iot-page-header">

                <div>

                    <h3>

                        {id ? "Edit IoT Gateway" : "Register IoT Gateway"}

                    </h3>

                    <p>
                        Configure an agricultural IoT gateway
                    </p>

                </div>

            </div>


            {/* ====================================================
                GATEWAY CONFIGURATION
            ==================================================== */}

            <div className="card shadow-sm">

                <div className="card-header">

                    <strong>
                        Gateway Configuration
                    </strong>

                </div>


                <div className="card-body">


                    <form onSubmit={submitHandler}>


                        {/* ==================================================
                            BASIC INFORMATION
                        ================================================== */}

                        <div className="row">


                            <div className="col-md-6 mb-3">

                                <label className="form-label">

                                    Gateway ID *

                                </label>


                                <input
                                    type="text"
                                    name="gateway_id"
                                    className="form-control"
                                    placeholder="GW-FARM-01"
                                    value={formData.gateway_id}
                                    onChange={inputHandler}
                                    disabled={!!id}
                                />

                            </div>


                            <div className="col-md-6 mb-3">

                                <label className="form-label">

                                    Gateway Name *

                                </label>


                                <input
                                    type="text"
                                    name="gateway_name"
                                    className="form-control"
                                    placeholder="Main Farm IoT Gateway"
                                    value={formData.gateway_name}
                                    onChange={inputHandler}
                                />

                            </div>


                        </div>


                        {/* ==================================================
                            NETWORK
                        ================================================== */}

                        <div className="row">


                            <div className="col-md-6 mb-3">

                                <label className="form-label">

                                    IP Address

                                </label>


                                <input
                                    type="text"
                                    name="ip_address"
                                    className="form-control"
                                    placeholder="192.168.1.10"
                                    value={formData.ip_address}
                                    onChange={inputHandler}
                                />

                            </div>


                            <div className="col-md-6 mb-3">

                                <label className="form-label">

                                    Port

                                </label>


                                <input
                                    type="number"
                                    name="port"
                                    className="form-control"
                                    placeholder="8080"
                                    value={formData.port}
                                    onChange={inputHandler}
                                />

                            </div>


                        </div>


                        {/* ==================================================
                            AGRICULTURAL DEPLOYMENT
                        ================================================== */}

                        <div className="row">


                            <div className="col-md-4 mb-3">

                                <label className="form-label">

                                    Farm Code

                                </label>


                                <input
                                    type="text"
                                    name="farm_code"
                                    className="form-control"
                                    placeholder="FARM-001"
                                    value={formData.farm_code}
                                    onChange={inputHandler}
                                />

                            </div>


                            <div className="col-md-4 mb-3">

                                <label className="form-label">

                                    Deployment Location

                                </label>


                                <input
                                    type="text"
                                    name="location"
                                    className="form-control"
                                    placeholder="Main Farmland"
                                    value={formData.location}
                                    onChange={inputHandler}
                                />

                            </div>


                            <div className="col-md-4 mb-3">

                                <label className="form-label">

                                    Gateway Version

                                </label>


                                <input
                                    type="text"
                                    name="version"
                                    className="form-control"
                                    placeholder="1.0.0"
                                    value={formData.version}
                                    onChange={inputHandler}
                                />

                            </div>


                        </div>


                        {/* ==================================================
                            STATUS
                        ================================================== */}

                        <div className="row">


                            <div className="col-md-6 mb-3">

                                <label className="form-label">

                                    Status

                                </label>


                                <select
                                    name="status"
                                    className="form-control"
                                    value={formData.status}
                                    onChange={inputHandler}
                                >

                                    <option value="ONLINE">
                                        Online
                                    </option>

                                    <option value="OFFLINE">
                                        Offline
                                    </option>

                                    <option value="MAINTENANCE">
                                        Maintenance
                                    </option>

                                </select>

                            </div>


                        </div>


                        {/* ==================================================
                            INFORMATION
                        ================================================== */}

                        <div className="alert alert-info mt-2">

                            <strong>
                                Agricultural IoT Gateway
                            </strong>

                            <div className="mt-1">

                                This gateway collects sensor data
                                from agricultural IoT devices deployed
                                across farmland and forwards the data
                                to eAgri.

                            </div>

                        </div>


                        {/* ==================================================
                            BUTTONS
                        ================================================== */}

                        <div className="text-center mt-4">


                            <button
                                type="button"
                                className="btn btn-secondary me-2"
                                onClick={() => navigate("/iot-gateways/")}
                            >

                                Cancel

                            </button>


                            <button
                                type="submit"
                                className="btn btn-success"
                                disabled={loading}
                            >

                                {loading ? "Saving..." : id ? "Update Gateway" : "Register Gateway"}

                            </button>


                        </div>


                    </form>

                </div>

            </div>

        </section>);
}
export default IoTGatewayForm;